const contain = { label: '包含', value: 'contain' };
const notContain = { label: '不包含', value: 'not_contain' };
const equal = { label: '是', value: 'eq' };
const notEqual = { label: '不是', value: 'neq' };
const exist = { label: '不为空', value: 'exist' };
const notExist = { label: '为空', value: 'not_exist' };
const gt = { label: '大于', value: 'gt' };
const lt = { label: '小于', value: 'lt' };

export const fieldConfigList = [
  { label: '文本', value: 'string' },
  { label: '数字', value: 'number' },
  { label: '时间', value: 'date' },
  { label: '单选', value: 'radio' },
  { label: '复选', value: 'check' }
];

const temp = {};

fieldConfigList.forEach(item => {
  temp[item.value] = item.label;
});

export const fieldConfigMap = temp;

export const range = { label: '范围', value: 'range' };

export const date = [equal, range, gt, lt, notExist, exist];

export const name = [equal, notEqual, contain, notContain];

export const str = [equal, notEqual, contain, notContain, notExist, exist];

export const number = [equal, notEqual, notExist, exist];

export const text = [equal, notEqual, notExist, exist];

export const radio = [equal, notEqual];

export const check = [equal, notEqual];

export const bool = [
  { label: '是', value: true },
  { label: '否', value: false }
];

export const gender = [
  { label: '男', value: '男' },
  { label: '女', value: '女' },
  notExist,
  exist
];

export const genderValue = [{ label: '男', value: 'M' }, { label: '女', value: 'F' }, notExist, exist];

export const genderSelect = [
  { label: '男', value: 'M' },
  { label: '女', value: 'F' }
];

export const customer = [contain, notContain, notExist, exist];

export const conditionConfig = {
  contain,
  not_contain: notContain,
  eq: equal,
  neq: notEqual,
  not_exist: notExist,
  exist,
  gt,
  lt,
  男: gender[0],
  女: gender[1],
  M: gender[0],
  F: gender[1],
  range
};

export const utmConfig = {
  utm_source: 'source',
  utm_medium: 'medium',
  utm_term: 'term',
  utm_content: 'content',
  utm_campaign: 'campaign'
};

//
export const channelConfig = {
  source_source: '来源取值',
  url: '对话页网址'
};

// 基础顾客信息
export const baseConfig = {
  name: '姓名',
  gender: '性别',
  tel: '电话',
  email: '邮箱',
  qq: 'QQ',
  weixin: '微信',
  weibo: '微博',
  address: '地址',
  comment: '备注',
  age: '年龄',
  tag: '顾客标签',
  contact: '联系人'
};

// 来源信息
export const sourceConfig = {
  ip: 'IP地址',
  country: '国家',
  province: '省份',
  city: '城市',
  os_family: '操作系统',
  browser_family: '浏览器',
  source_type: '来源类型',
  source_url: '来路页网址',
  source_domain: '来路页域名',
  landing_page_title: '着陆页标题',
  landing_page_url: '着陆页网址',
  source_keyword: '搜索词',
  source: '来源'
};

export const customerDateConfig = {
  created_on: '创建顾客时间',
  updated_on: '更新时间',
  latest_conv_on: '最近一次对话时间',
  latest_visit_on: '最近一次访问时间'
};

// 总的字段名称和name配置对应
export const fieldConfig = {
  ...baseConfig,
  ...sourceConfig,
  ...channelConfig,
  ...utmConfig,
  ...customerDateConfig
};

export const filterModal = {
  string: str,
  number,
  date,
  bool,
  radio,
  check,
  name,
  customer
};

export const sourceTypeConfig = {
  direct: '直接访问',
  search: '搜索引擎',
  referral: '第三方链接',
  campaign: '其他',
  toutiao: '今日头条',
  toutiao_microapp: '头条小程序',
  kuaishou: '快手',
  baidu_bcp: '百度bcp',
  appsdk: 'SDK',
  sdk: 'SDK',
  weixin: '微信',
  weibo: '微博',
  mult_channel: '开放平台'
};

export const sourceSourceConfig = {
  pc: '桌面网站',
  mobile: '手机网站',
  appsdk: 'SDK',
  weixin: '微信',
  weibo: '微博',
  toutiao: '今日头条',
  toutiao_microapp: '头条小程序',
  kuaishou: '快手',
  mini_program: '微信小程序',
  baidu_bcp: '百度bcp',
  direct: '直接访问',
  search: '搜索引擎',
  referral: '第三方链接',
  campaign: '其他',
  source: '来源',
  talk_page: '对话页',
  landing_page: '着陆页',
  search_engine: '搜索引擎',
  keyword: '关键字',
  desktop: '桌面网站',
  '360search': '360搜索',
  baidu: '百度',
  google: '谷歌',
  sogou: '搜狗',
  sdk: 'SDK',
  sm: '神马',
  haosou: '好搜',
  bing: '必应',
  wechat: '微信',
  unknown: '未知',
  empty: '未知',
  mult_channel: '开放平台'
};

export default {
  fieldConfig,
  date,
  name,
  str,
  number,
  text,
  radio,
  gender,
  conditionConfig,
  fieldConfigMap,
  fieldConfigList
};
